import React from 'react';
import ModalV1 from '../../../resuable-ui/modal-v1/index';
import PriceMarkupContent from '../../../resuable-ui/modals-mobile/price-markup-content';

interface Props {
	show: boolean;
	setShow: (v: boolean) => void;
	productId: string;
	productName?: string;
	originalPrice: number;
	onApply: (price: number) => void;
}

const PriceMarkupModal: React.FC<Props> = ({ show, setShow, productId, productName, originalPrice, onApply }) => {
	return (
		<ModalV1
			classes={{ content: 'z-[500]' }}
			show={show}
			onClose={() => setShow(false)}
			headerAction={<div className="text-base font-semibold text-gray-900">Adjust Price Unit</div>}
		>
			<PriceMarkupContent
				productId={productId}
				productName={productName}
				originalPrice={originalPrice}
				onApply={onApply}
				onClose={() => setShow(false)}
			/>
		</ModalV1>
	);
};

export default PriceMarkupModal;
